import classNames from 'classnames'
import { useCallback } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { TPopupHorizontal } from 'core-components/library/popup'
import { getActionIconColor } from 'core-components/library/richTextEditor/helpers/actionHelper'
import { insertActionBlock } from 'core-components/library/richTextEditor/helpers/slateHelper'
import {
  ACTION_FORMATS,
  ACTION_TYPES,
} from 'core-components/library/richTextEditor/interface/custom-types'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { Tooltip } from 'core-components/library/tooltip'
import { BaseCrud, Static } from 'core-components/types'

import { TOOLBAR_TITLES } from '../../constants'

interface IProps {
  disabled: boolean
  className?: string
}

export const ActionBoxButton = (props: IProps) => {
  const editor = useSlate()
  const actionItems = ACTION_TYPES.map((item) => ({
    key: item.style,
    label: item.label,
    icon: item.icon,
  }))
  const source = new BaseCrud({
    fetcher: new Static(actionItems),
    keyField: 'key',
  })
  const onSelectActionBox = useCallback((variant: string) => {
    insertActionBlock(editor, variant as ACTION_FORMATS)
  }, [])
  return (
    <Menu
      content={() => (
        <Button
          className={props.className}
          disabled={props.disabled}
          iconButton="kbase kbase-info"
          title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.Action]}
          variant={'text'}
          color={'grey'}
        />
      )}
      onChoose={onSelectActionBox}
      source={source}
      itemTpl={(item) => {
        return (
          <Tooltip
            tipContent={() => <>{item.label}</>}
            horizontalStartPosition={TPopupHorizontal.Right}
            horizontalDirection={TPopupHorizontal.Right}
          >
            <i className={classNames(getActionIconColor(item.key), item.icon)} />
          </Tooltip>
        )
      }}
    />
  )
}
